var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPowerBackup = function SvgPowerBackup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0c8.833.01 15.99 7.167 16 16 0 8.837-7.163 16-16 16S0 24.837 0 16 7.163 0 16 0m5.867 13.333h-3.333a.334.334 0 0 1-.277-.518l2.619-3.928a1 1 0 0 0-.831-1.553H15.08c-.505 0-.967.284-1.193.736l-4.243 8.487a1 1 0 0 0 .891 1.444h2.08a.332.332 0 0 1 .316.439l-2.229 6.684a.666.666 0 0 0 1.105.683l10.765-10.765a1 1 0 0 0-.704-1.706z"
  })));
};
export default SvgPowerBackup;